import { render, staticRenderFns } from "./min-title.vue?vue&type=template&id=6de784c9&scoped=true&"
import script from "./min-title.vue?vue&type=script&lang=js&"
export * from "./min-title.vue?vue&type=script&lang=js&"
import style0 from "./min-title.vue?vue&type=style&index=0&id=6de784c9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6de784c9",
  null
  
)

export default component.exports